import { getItemsFromApiResponse } from '../../../../utils/api'
import { InputAsyncSelect, InputSelectControl } from '../../../Select'
import { getVariableList } from '../DocFlowVariableField.api'

import { toDocFlowVariableSelectItems } from './DocFlowVariableSelect.utils'

function DocFlowVariableSelect({
  Control = InputSelectControl,
  getData = getVariableList,
  getDataItems = getItemsFromApiResponse,
  toPreparedItems = toDocFlowVariableSelectItems,
  ...restProps
}) {
  return (
    <InputAsyncSelect
      {...restProps}
      Control={Control}
      getData={getData}
      getDataItems={getDataItems}
      toPreparedItems={toPreparedItems}
    />
  )
}

export default DocFlowVariableSelect
